var $export = require('./_export');
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: require('./_object-create') });



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/modules/es6.object.create.js